module.exports = __webpack_public_path__ + "img/pic8.6b8ac9ba.png";